export default __webpack_public_path__ + "static/media/icon_ui_checkbox_on.52fb3975.png";